import classNames from 'classnames';
import React, { ComponentProps } from 'react';
import { DesktopVerticalTabMenuItem } from './DesktopVerticalTabMenuItem/DesktopVerticalTabMenuItem';
import styles from './DesktopVerticalTabMenu.module.scss';

export type DesktopVerticalTabMenuItemValue = string;

type DesktopVerticalTabMenuProps = ComponentProps<'ul'> & {
	items: Array<{
		value: DesktopVerticalTabMenuItemValue;
		label: string;
		href?: string;
	}>;
	selectedItemValue: DesktopVerticalTabMenuItemValue;
	onItemClick: (value: DesktopVerticalTabMenuItemValue) => void;
};

export const DesktopVerticalTabMenu: React.FC<DesktopVerticalTabMenuProps> = ({ items, selectedItemValue, className, onItemClick, ...restProps }) => {
	return (
		<ul className={classNames(styles.container, className)} {...restProps}>
			{items.map((item) => (
				<DesktopVerticalTabMenuItem
					href={item.href}
					key={item.value}
					selected={selectedItemValue === item.value}
					onClick={() => onItemClick(item.value)}
				>
					{item.label}
				</DesktopVerticalTabMenuItem>
			))}
		</ul>
	);
};
